<template>
  
    <div v-if="Object.keys(activeFilters).length" class="flex items-center mt-3">

        <div class="mr-3">
            <i class="fal fa-filter mr-1"></i>
            {{ Object.keys(activeFilters).length }} filter{{ Object.keys(activeFilters).length !== 1 ? 's' : '' }} actief: 
        </div>
        
        <div v-for="(value, name)  in activeFilters" 
            :key="name"
            class="bg-white px-2 py-1 rounded mr-1 cursor-pointer hover:line-through" 
            @click="$emit('remove-filter', name)" 
        >{{ name.replace('filter_', '') }}: {{ value }}</div>

    </div>

</template>

<script>

export default {
  props: {
    filters: Object,
  },
  computed:{
        activeFilters(){
            return _.pickBy(this.filters, (value, key) => {
              return value != null && key != 'orderBy' && key != 'sortOrder';
            });
        }
    }
}
</script>
